import {create} from 'zustand';
import {createSelectors} from './zustand';

interface RightClickState {
    limitedRightClickIds: string[];
    setLimitedRightClickIds: (value: string[]) => void;
}

const useRightClickStateBase = create<RightClickState>()((set) => ({
    limitedRightClickIds: [],
    setLimitedRightClickIds: (v) => set(() => ({limitedRightClickIds: v})),
}));

export const useRightClickState = createSelectors(useRightClickStateBase);
